import React, { useContext } from 'react';
import { useGetHompagedata } from '../../views/Home/HomepageApi';
import LanguageContext from '../../views/languageContext/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from './api';
import { useGetProfile } from '../../views/Myprofile/api';
import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../../Loader/buttonLoad';

const Footer = (props) => {

    const { language } = useContext(LanguageContext)
    const { t } = useTranslation()

    const { data: Homepagedata } = useGetHompagedata({

        language: language
    });

    const navigate = useNavigate();

    React.useEffect(() => { window.scrollTo(0, 0); }, []);







    const { data: getProfile } = useGetProfile()

    const { isloading, setIsloading } = useModalContext();


    const subcription = useSubscription()
    const subcriptionSubmit = async (data) => {
        setIsloading(true)

        if (!sessionStorage.getItem('user_JWT')) {
            navigate('/login')
            setIsloading(false)
            return
        }

        try {
            setIsloading(true)
            await subcription.mutateAsync({ email: getProfile?.data?.email })



        } catch (error) {
            setIsloading(false)
        } finally {
            setIsloading(false)
        }
    };
    return (
        <>
            {isloading && <Loader />}
            <div className="FtrSec">
                <div className="container">
                    <div className='FtrSecMnLk'>
                        <div className='row pb-3'>
                            <div className='col-lg-4 col-md-6'>
                                <button className='EpySty'>
                                    <img src={Homepagedata?.data[0]?.footer_logo} alt='' />
                                </button>
                                <p dangerouslySetInnerHTML={{ __html: Homepagedata?.data[0]?.footer_description }}></p>
                            </div>
                            <div className='col-lg-2 col-md-6'>
                                <h4>{t('Quick Link')}</h4>
                                <ul>
                                    <li><a href='/#banner'>{t('Pre-sale')}</a></li>
                                    <li><a href='/#tokensale'>{t('Tokens')}</a></li>
                                    <li><a href='/#faq'>{t('FAQ')}</a></li>
                                    <li><a href='/howitworks'>{t('How it works')}</a></li>
                                </ul>
                            </div>
                            <div className='col-lg-2 col-md-6'>
                                <ul className='h4Empty'>
                                    <li><a href='/terms'>{t('Terms & Conditions')}</a></li>
                                    <li><a href='/privacy'>{t('Privacy Policy')}</a></li>
                                </ul>
                            </div>
                            <div className='col-lg-4 col-md-6'>
                                <h4>{t('Newsletter')}</h4>
                                <h6 dangerouslySetInnerHTML={{ __html: Homepagedata?.data[0]?.newsletter_description }}></h6>
                                <div className='NwsLtrDv'>
                                    <input className='form-control' type='text'
                                        value={getProfile?.data?.email}
                                        disabled />

                                    <button className='btn CmnBtn' type='submit'
                                        onClick={subcriptionSubmit}
                                    >{t('Submit')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="CpyRgts">© 2026 KKOG. {t('All Right Reserved')}.</p>
                </div>
            </div>
        </>
    );
}

export default Footer;

